const K = {
  collections: {
    profile: {
      name: "profile",
      doc: "data",
    },
    experience: {
      name: "experience",
    },
    education: {
      name: "education",
    },
    projects: {
      name: "projects",
    },
    certifications: {
      name: "certifications",
    },
    skillSets: {
      name: "skills",
    },
  },
  app: {
    months: [
      {
        index: 1,
        name: "January",
        shortName: "Jan",
      },
      {
        index: 2,
        name: "February",
        shortName: "Feb",
      },
      {
        index: 3,
        name: "March",
        shortName: "March",
      },
      {
        index: 4,
        name: "April",
        shortName: "April",
      },
      {
        index: 5,
        name: "May",
        shortName: "May",
      },

      {
        index: 6,
        name: "June",
        shortName: "June",
      },
      {
        index: 7,
        name: "July",
        shortName: "July",
      },
      {
        index: 8,
        name: "August",
        shortName: "Aug",
      },
      {
        index: 9,
        name: "September",
        shortName: "Sep",
      },
      {
        index: 10,
        name: "October",
        shortName: "Oct",
      },
      {
        index: 11,
        name: "November",
        shortName: "Nov",
      },
      {
        index: 12,
        name: "December",
        shortName: "Dec",
      },
    ],
    certificateTypes: [
      "Bootcamp",
      "Competition",
      "Course",
      "Seminar",
      "Specialization",
      "Workshop",
    ],
  },
};

export default K;
